(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('SupplierDialogController', SupplierDialogController);

    SupplierDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Supplier'];

    function SupplierDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Supplier) {
        var vm = this;

        vm.supplier = entity;
//        vm.supplier1 = [{code:'AD',name:'Á Đông', typeService:'In giấy giới thiệu trích sao HS bệnh án',userContact:'Anh Trung',phone:'3551 0831',status:'1'},
//                       {code:'BD',name:'In tem Bưu Điện', typeService:'Bao thư cửa sổ phải, bao thư 11x17, giấy tiêu đề tờ 1',userContact:'Anh Đình Hải',phone:'3551 0831',status:'1'},
//                       {code:'BNP',name:'Công ty cổ phần đầu tư DVN', typeService:'Giấy tiêu đề liên tục 2 liên, 3 liên',userContact:'Anh Đình Hải',phone:'3551 0831',status:'1'},
//                       {code:'DVN',name:'Cty Cổ Phần In Tổng Hợp Cần Thơ', typeService:'Sách',userContact:'Anh Trang',phone:'3551 0831',status:'1'},
//                       {code:'FA',name:'In Trần Phú', typeService:'GCN, ĐKHĐ, Bìa Regular & bìa VIP',userContact:'thuylinh@vaikhongdet.vn (094 982 7071 - 0917 548 045)',phone:'3551 0831',status:'1'}];
//        vm.supplier = vm.supplier1[0];
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.checkcreat = false;
        if (vm.supplier.providerCode != null || vm.supplier.providerCode != undefined) {
       	 vm.checkcreat = true;
       	vm.supplier.isExit = true;
        }else{
    	   vm.supplier.isExit = false;
    	   vm.supplier.status="0";
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	$scope.clearMessage();
            vm.isSaving = true;
            if (vm.supplier.isExit == true) {
            	
            	Supplier.update(vm.supplier,function(result){
          		  $scope.$emit('masterApp:supplierUpdate', result);
                  $uibModalInstance.close(result);
                  vm.isSaving = false;
        	},function(error) {
        		vm.isSaving = false;
		});
            } else {
            	Supplier.save(vm.supplier,function(result){
        		  $scope.$emit('masterApp:supplierUpdate', result);
                  $uibModalInstance.close(result);
                  vm.isSaving = false;
            	},function(error) {
            		vm.isSaving = false;
    		});
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('masterApp:supplierUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }



    }
})();
